"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

require("core-js/modules/es6.reflect.construct.js");

require("core-js/modules/es6.object.assign.js");

require("core-js/modules/es6.symbol.js");

require("core-js/modules/es6.string.iterator.js");

require("core-js/modules/es6.object.to-string.js");

require("core-js/modules/es6.array.iterator.js");

require("core-js/modules/web.dom.iterable.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es6.object.set-prototype-of.js");

require("core-js/modules/es6.object.get-prototype-of.js");

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("../../../sass/components/shared/DropDown.css");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var DropDown = /*#__PURE__*/function (_React$Component) {
  _inherits(DropDown, _React$Component);

  var _super = _createSuper(DropDown);

  function DropDown() {
    var _this;

    _classCallCheck(this, DropDown);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    _this.state = {
      collapsed: true
    };
    _this.headerRef = /*#__PURE__*/_react.default.createRef();
    _this.paneRef = /*#__PURE__*/_react.default.createRef();

    _this.handleOutsideClick = function (_ref) {
      var target = _ref.target;
      var cHeaderRef = _this.headerRef.current;
      var cPaneRef = _this.paneRef.current;
      var isOutsideClick = !(cHeaderRef && cHeaderRef.contains(target) || cPaneRef && cPaneRef.contains(target));
      isOutsideClick && _this.toggle();
    };

    _this.toggle = function () {
      var collapsed = _this.state.collapsed;

      if (collapsed) {
        window.addEventListener('mousedown', _this.handleOutsideClick, false);
        window.addEventListener('touchstart', _this.handleOutsideClick, false);
      } else {
        window.removeEventListener('mousedown', _this.handleOutsideClick, false);
        window.removeEventListener('touchstart', _this.handleOutsideClick, false);
      }

      _this.setState({
        collapsed: !collapsed
      });
    };

    return _this;
  }

  _createClass(DropDown, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          header = _this$props.header,
          pane = _this$props.pane,
          direction = _this$props.direction,
          anchorDirection = _this$props.anchorDirection,
          addClass = _this$props.addClass,
          disabled = _this$props.disabled;
      var collapsed = this.state.collapsed;
      var exportOpts = {
        togglePane: this.toggle
      };
      var dropdownClasses = "wa-dropdown ".concat(addClass).trim();
      var headerClasses = (0, _classnames.default)('wa-dropdown-header', {
        disabled: disabled
      });
      var paneClasses = (0, _classnames.default)('wa-dropdown-pane', direction, {
        collapsed: collapsed
      });
      var triangleClasses = (0, _classnames.default)('wa-dropdown-triangle', {
        collapsed: collapsed,
        anchorBelow: anchorDirection === 'below'
      });
      var clickHandler = {};
      !disabled && (clickHandler.onClick = this.toggle);
      return /*#__PURE__*/_react.default.createElement("div", {
        className: dropdownClasses
      }, /*#__PURE__*/_react.default.createElement("div", _extends({}, clickHandler, {
        className: headerClasses,
        ref: this.headerRef
      }), header), /*#__PURE__*/_react.default.createElement("div", {
        className: paneClasses,
        ref: this.paneRef
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: "wa-close-pane",
        onClick: this.toggle
      }, /*#__PURE__*/_react.default.createElement("div", {
        className: triangleClasses
      })), typeof pane === 'function' ? pane(exportOpts) : pane));
    }
  }]);

  return DropDown;
}(_react.default.Component);

exports.default = DropDown;
DropDown.propTypes = {
  header: _propTypes.default.element,
  pane: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.func]),
  direction: _propTypes.default.string,
  anchorDirection: _propTypes.default.string,
  addClass: _propTypes.default.string,
  disabled: _propTypes.default.bool
};
DropDown.defaultProps = {
  header: /*#__PURE__*/_react.default.createElement("div", null),
  pane: /*#__PURE__*/_react.default.createElement("div", null),
  direction: 'left',
  anchorDirection: 'above',
  addClass: '',
  disabled: false
};